// src/Pages/Privacy/Privacy.jsx
import React, { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { initAOS } from "../../helpers/aosConfig";
import SectionWrapper from "../../components/SectionWrapper/SectionWrapper";

const privacyParagraphs = [
  "Bilebändi Joyride kunnioittaa yksityisyyttäsi ja noudattaa EU:n yleistä tietosuoja-asetusta (GDPR). Tässä kuvaamme, mitä tietoja keräämme, miksi ja miten voit hallita omia tietojasi.<br /><br />",
  "Sivustomme käyttää evästeitä parantaakseen käyttökokemusta ja kerätäkseen tilastotietoja kävijöistä. Evästeistä kerrotaan tarkemmin alla.",
  "<strong>Evästeet</strong>: Kun hyväksyt evästeet, sivusto tallentaa pienen datatiedoston selaimeesi, jonka avulla muistat vaikkapa teemavalinnan tai hakuasetukset.<br /><br />",
  "<strong>Analytiikkaevästeet</strong>: Google Analytics (GA4) kerää anonymisoituja kävijätilastoja (IP-osoitteet anonymisoidaan). Lataamme tämän skriptin vain, jos hyväksyt analytiikkaevästeet evästebannerista.<br /><br />",
  "<strong>Välttämättömät evästeet</strong>: Nämä evästeet ovat välttämättömiä sivuston perustoimintoihin, kuten evästebannerin tilan ja käyttäjäasetusten tallentamiseen.<br /><br />",
  "<strong>Yhteydenotto</strong>: Jos sinulla on kysyttävää tietosuojasta, ota yhteyttä sähköpostitse: info@bilebandijoyride.com.",
];

export default function Privacy() {
  useEffect(() => {
    initAOS();
  }, []);

  return (
    <>
      <Helmet>
        <title>Bilebändi Joyride | Tietosuoja ja evästekäytäntö</title>
        <meta
          name="description"
          content="Bilebändi Joyriden evästekäytäntö ja tietosuojaseloste — mitä tietoja keräämme, miksi ja miten voit hallita niitä."
        />
        <link rel="canonical" href="https://bilebandijoyride.com/privacy" />
      </Helmet>

      <SectionWrapper id="privacy">
        <div className="relative prose max-w-none prose-lg dark:prose-invert text-joyrideNavy dark:text-joyrideLight pt-10 space-y-4">
          <h2
            className="text-4xl font-bold font-lobster text-joyridePurple dark:text-joyrideCyan mb-6 dark:text-shadow-lg"
            data-aos="fade-up"
          >
            Tietosuoja ja evästekäytäntö
          </h2>

          {privacyParagraphs.map((text, idx) => (
            <p key={idx} data-aos="fade-up">
              {text.split("<br />").map((part, i) => (
                <React.Fragment key={i}>
                  {i > 0 && <br />}
                  <span
                    dangerouslySetInnerHTML={{ __html: part }}
                  />
                </React.Fragment>
              ))}
            </p>
          ))}
        </div>
      </SectionWrapper>
    </>
  );
}
